import * as React from 'react';

const SvgInterview = (props) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2 6.66667L2 9.33333M5 4L5 12M8 2V14M11 4V12M14 6.66667V9.33333"
      stroke="#161616"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SvgInterview;
